import { t } from 'i18next';
import { useEffect } from 'react';
import Login from '../components/mplat/Login';

function LoginPage() {
    useEffect(() => { document.title = t('Sign'); }, [t]);

    return (
        <Login />
    )
}

export default LoginPage;
